module.exports = __webpack_public_path__ + "img/icon_l_pp.a9ca896d.png";